module.exports = __webpack_public_path__ + "static/img/20.8e74d62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/20.png
// module id = aDvm
// module chunks = 1